import { render, staticRenderFns } from "./SobreEvento.vue?vue&type=template&id=574fdf5c&"
import script from "./SobreEvento.vue?vue&type=script&lang=js&"
export * from "./SobreEvento.vue?vue&type=script&lang=js&"
import style0 from "./SobreEvento.vue?vue&type=style&index=0&id=574fdf5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports